import React, {useContext, useState} from 'react';
import firebase from 'firebase';

import * as dataManager from '../adapters/data';

import { Button, Dropdown, Input, Modal } from 'semantic-ui-react';
import { GlobalContext } from '../contexts/GlobalContext';


const AddQualificationModal = (props) => {

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [employees, setEmployees] = useState([]);
    const [context, setContext] = useContext(GlobalContext);

    const addQualification = () => {

        if (name.trim() === '') {
            // display error, must fill out field
        }

        else {
            console.log('Qualification Added');
            props.onClose();

            let id = dataManager.addQualification(name, description);
            employees.map( (e) => {
                let d = JSON.parse(e);
                console.log(JSON.stringify(d.id));

                dataManager.editEmployee(d.id, d.name, [...d.qualifications, {id: id, name: name} ]);
            });

            props.refreshListCb();
        }


        // const editEmployee = () => {

        //     console.log(`Name: ${state['editModal'].name}`);
        //     console.log(state['editModal'].id);
        //     console.log('Employee Edited - ' + state['editModal'].id);
        //     props.onClose();
    
        //     dataManager.editEmployee(state['editModal'].id, state['editModal'].name, state['editModal'].qualifications);
        //     props.onEdit();
    
            
            
        // }
    }

    const updateName = (e) => {
        setName(e.target.value);
    }
    
    const updateDescription = (e) => {
        setDescription(e.target.value);
        console.log(e.target.value);
    }

    const updateEmployees = (e, data) => {
        setEmployees(data.value);
        
    }
    
    return (
        <div>

            <Modal dimmer='blurring' open={props.show}
            >
            <Modal.Header>Add Qualification</Modal.Header>
            <Modal.Content>
                <Input placeholder='Name' onChange={updateName} />
                <Input placeholder='Description' onChange={updateDescription} />
                <br /><br />

                Employees with Qualification
                <br /><br />
                <div style={{display: 'flex'}}>
                    <Dropdown
                        fluid
                        multiple
                        search
                        selection
                        placeholder='Select the employees you wish to have this qualification'
                        options={ context['employees'] ? context['employees'].map( (q) => ({key: q.id, text: q.name, value:  JSON.stringify({id: q.id, name: q.name, qualifications: q.qualifications})} )) : []}
                        // defaultValue= { context['employees'] ? context['employees']
                        //     .map( (q) => ({key: q.name, text: q.name, value: q.name} ))
                        //     .filter() : [] }

                        
                        value={employees}
                        // defaultValue={ context['employees'].reduce(function(filtered, option) {
                        //     if (option.qualifications.includes(name)) {
                        //         var someNewValue = { key: option.id, text: option.name, value: option.name }
                        //         filtered.push(someNewValue);
                        //     }
                        //     return filtered;
                        // }, [])
                        // }

                        onChange={updateEmployees}
                            
                        
                        // options={state['qualifications'] ? state['qualifications'].map( (q) => ({key: q.name, text: q.name, value: q.name} )) : []}
                    /><div>
                    <Button basic onClick={ () => {
                        setEmployees( context['employees'] ? context['employees'].map( (q) => (JSON.stringify({id: q.id, name: q.name, qualifications: q.qualifications}) )) : [] )
                    }} >
                    Select All
                    </Button>
                    <Button basic onClick={ () => {
                        setEmployees( [] )
                    }} >
                    Clear All
                    </Button></div>
                </div>
                
            </Modal.Content>
            <Modal.Actions>
                <Button basic onClick={props.onClose} >
                Cancel
                </Button>
                <Button color='blue' onClick={addQualification} >
                Add
                </Button>
            </Modal.Actions>
            </Modal>
        </div>
    );
};

export default AddQualificationModal;